<div class="card">
  <div class="card-content outing-summary-page">

    <!-- Stat cards -->
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ report?.totalOutings ?? 0 }}</span>
          <span class="stats-card-label">Total outings</span>
          <span class="stats-card-sublabel">
            {{ report?.plannedCount ?? 0 }} planned · {{ report?.confirmedCount ?? 0 }} confirmed · {{ report?.completedCount ?? 0 }} completed
          </span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-calendar"></i></div>
      </div>

      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ (report?.totalBudget ?? 0) | number:'1.0-0' }}</span>
          <span class="stats-card-label">Total budget</span>
          <span class="stats-card-sublabel">Spent: {{ (report?.totalActualSpend ?? 0) | number:'1.0-0' }}</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-wallet"></i></div>
      </div>

      <div class="stats-card stats-card--warning">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ (report?.participationRate ?? 0) | number:'1.0-1' }}%</span>
          <span class="stats-card-label">Participation rate</span>
          <span class="stats-card-sublabel">Across completed outings</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-users"></i></div>
      </div>

      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ report?.completedCount ?? 0 }}</span>
          <span class="stats-card-label">Completed</span>
          <span class="stats-card-sublabel">{{ report?.cancelledCount ?? 0 }} cancelled</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
    </div>

    <!-- All filters + name search in one collapsible row (toggled by the header funnel) -->
    <div class="filter-bar filter-bar-collapsible mb-4"
         [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label class="filter-label">Year</label>
          <p-select [options]="yearOptions" [(ngModel)]="filterYear" (onChange)="onFilterChange()"
                    optionLabel="label" optionValue="value" panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
        </div>
        <div class="filter-field">
          <label class="filter-label">Quarter</label>
          <p-select [options]="quarterOptions" [(ngModel)]="filterQuarter" (onChange)="onFilterChange()"
                    optionLabel="label" optionValue="value" [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
        </div>
        <div class="filter-field">
          <label class="filter-label">Project</label>
          <p-select [options]="projectFilterOptions" [(ngModel)]="filterProjectId" (onChange)="onFilterChange()"
                    optionLabel="label" optionValue="value" [filter]="true" [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
        </div>
        <div class="filter-field">
          <label class="filter-label">Service Group</label>
          <p-select [options]="serviceGroupOptions" [(ngModel)]="filterServiceGroupId"
                    optionLabel="label" optionValue="value" [filter]="true" [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
        </div>
        <div class="filter-field">
          <label class="filter-label">Participation</label>
          <p-select [options]="countBucketOptions" [(ngModel)]="filterCountBucket"
                    optionLabel="label" optionValue="value" [showClear]="true" panelStyleClass="filter-dropdown-panel" appendTo="body"></p-select>
        </div>
        <div class="filter-field">
          <label class="filter-label">Search</label>
          <span class="search-box">
            <i class="pi pi-search"></i>
            <input pInputText [(ngModel)]="nameSearch" placeholder="Employee name…" class="search-input" />
            <i class="pi pi-times search-clear" *ngIf="nameSearch" (click)="nameSearch = ''" title="Clear"></i>
          </span>
        </div>
      </div>
      <div class="filter-bar-actions">
        <button type="button" *ngIf="hasActiveFilters()" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <!-- Tabs (left) + quarter breakdown chips (right) on one line -->
    <div class="participation-header">
      <div class="participation-tabs">
        <button type="button" class="participation-tab" [class.active]="participationTab === 'participated'"
                (click)="participationTab = 'participated'">
          <i class="pi pi-check-circle"></i> Participation ({{ participatedRows.length }})
        </button>
        <button type="button" class="participation-tab" [class.active]="participationTab === 'notparticipated'"
                (click)="participationTab = 'notparticipated'">
          <i class="pi pi-ban"></i> Invited, not participated ({{ totalAbsentCount }})
        </button>
        <button type="button" class="participation-tab" [class.active]="participationTab === 'neverinvited'"
                (click)="participationTab = 'neverinvited'">
          <i class="pi pi-minus-circle"></i> Never invited ({{ neverInvitedRows.length }})
        </button>
      </div>
      <div class="quarter-strip" *ngIf="report && report.byQuarter.length">
        <div class="quarter-chip" *ngFor="let q of report.byQuarter">
          <span class="quarter-chip-label">{{ q.quarterLabel }}</span>
          <span class="quarter-chip-meta">{{ q.outingCount }} outing{{ q.outingCount === 1 ? '' : 's' }}</span>
          <span class="quarter-chip-meta">Budget {{ q.totalBudget | number:'1.0-0' }}</span>
          <span class="quarter-chip-meta" *ngIf="q.completedCount">Participation {{ q.participationRate | number:'1.0-1' }}%</span>
        </div>
      </div>
    </div>

    <!-- Participated employees (expand → their outings) -->
    <p-table *ngIf="participationTab === 'participated'"
             [value]="participatedRows" dataKey="employeeId"
             [loading]="loading" [paginator]="participatedRows.length > 15" [rows]="15" [rowsPerPageOptions]="[15, 25, 50]"
             [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} employees"
             styleClass="p-datatable-sm compact-striped-table">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem;"></th>
          <th>Employee</th>
          <th>Service Group</th>
          <th>Email</th>
          <th>Invited</th>
          <th>Participated</th>
          <th>Missed</th>
          <th>Participation</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-r>
        <tr>
          <td>
            <button type="button" class="row-toggle-btn" (click)="toggleExpand(r.employeeId)" pTooltip="View outings">
              <i class="pi" [class.pi-chevron-down]="expandedKeys[r.employeeId]" [class.pi-chevron-right]="!expandedKeys[r.employeeId]"></i>
            </button>
          </td>
          <td class="cell-strong">{{ r.employeeName }}</td>
          <td>{{ r.serviceGroupName || '—' }}</td>
          <td class="cell-sub">{{ r.email || '—' }}</td>
          <!-- Invited / Participated / Missed / rate — the bare "Participated" count alone didn't
               say whether 2 was good attendance or 2-out-of-8. -->
          <td>{{ invitedCountFor(r.employeeId) }}</td>
          <td><p-tag [value]="r.goneCount + ''" [severity]="r.goneCount >= 3 ? 'success' : 'info'" /></td>
          <td>
            <span *ngIf="missedCountFor(r.employeeId, r.goneCount) as missed; else noMissed"
                  class="cell-missed">{{ missed }}</span>
            <ng-template #noMissed><span class="cell-sub">—</span></ng-template>
          </td>
          <td>
            <p-tag [value]="(participationRateFor(r.employeeId, r.goneCount) | number:'1.0-0') + '%'"
                   [severity]="participationRateFor(r.employeeId, r.goneCount) >= 80 ? 'success'
                               : (participationRateFor(r.employeeId, r.goneCount) >= 50 ? 'warn' : 'danger')"
                   styleClass="chip-tag" />
          </td>
        </tr>
        <tr class="expansion-row" *ngIf="expandedKeys[r.employeeId]">
          <!-- 8 columns: toggle, employee, service group, email, invited, participated, missed, rate -->
          <td colspan="8">
            <div class="participant-panel">
              <div class="participant-panel-title participant-panel-title--ok">
                <i class="pi pi-check-circle"></i> Attended ({{ r.outings.length }})
              </div>
              <!-- Nested p-table so the header matches the main table's colours/columns exactly. -->
              <p-table [value]="r.outings" styleClass="p-datatable-sm compact-striped-table inner-outings-p-table">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Event</th>
                    <th>Project</th>
                    <th>PM</th>
                    <th>Date</th>
                    <th>Venue</th>
                    <th>Status</th>
                    <th>Participants</th>
                    <th>Photos</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-o>
                  <tr>
                    <td class="cell-strong cell-ellipsis" [pTooltip]="o.eventName" tooltipPosition="top">{{ o.eventName }}</td>
                    <td class="cell-ellipsis" [pTooltip]="o.projectName" tooltipPosition="top">{{ o.projectName }}</td>
                    <td class="cell-ellipsis" [pTooltip]="o.pmName" tooltipPosition="top">{{ o.pmName }}</td>
                    <td>{{ o.plannedDate | date:'mediumDate' }}<span class="cell-sub" *ngIf="o.startTime"> · {{ o.startTime }}</span></td>
                    <td class="cell-ellipsis" [pTooltip]="o.location" tooltipPosition="top">{{ o.location || '—' }}</td>
                    <td><p-tag [value]="statusLabel(o.status)" [severity]="statusSeverity(o.status)" styleClass="chip-tag" /></td>
                    <td>
                      <span class="participant-count"><i class="pi pi-users"></i> {{ o.participantCount }}</span>
                    </td>
                    <td>
                      <a *ngIf="o.photosFolderUrl" [href]="o.photosFolderUrl" target="_blank" rel="noopener"
                         pTooltip="View photos"><i class="pi pi-images"></i></a>
                      <span *ngIf="!o.photosFolderUrl" class="cell-sub">—</span>
                    </td>
                  </tr>
                </ng-template>
              </p-table>

              <!-- Invited but did not attend. Shown in the SAME panel so one expand answers both
                   "which did they go to" and "which did they miss" — the counts in the row above
                   are only useful if the events behind them are visible. -->
              <ng-container *ngIf="missedOutingsFor(r.employeeId).length as missedCount">
                <div class="participant-panel-title participant-panel-title--bad">
                  <i class="pi pi-ban"></i> Invited, but not attended ({{ missedCount }})
                </div>
                <p-table [value]="missedOutingsFor(r.employeeId)"
                         styleClass="p-datatable-sm compact-striped-table inner-outings-p-table">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Event</th>
                      <th>Project</th>
                      <th>PM</th>
                      <th>Date</th>
                      <th>Venue</th>
                      <th>RSVP</th>
                      <th>Participants</th>
                      <th>Photos</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-o>
                    <tr>
                      <td class="cell-strong cell-ellipsis" [pTooltip]="o.eventName" tooltipPosition="top">{{ o.eventName }}</td>
                      <td class="cell-ellipsis" [pTooltip]="o.projectName" tooltipPosition="top">{{ o.projectName }}</td>
                      <td class="cell-ellipsis" [pTooltip]="o.pmName" tooltipPosition="top">{{ o.pmName }}</td>
                      <td>{{ o.plannedDate | date:'mediumDate' }}<span class="cell-sub" *ngIf="o.startTime"> · {{ o.startTime }}</span></td>
                      <td class="cell-ellipsis" [pTooltip]="o.location" tooltipPosition="top">{{ o.location || '—' }}</td>
                      <!-- Confirmed-then-absent is the notable case, so it's flagged. -->
                      <td>
                        <span class="attendee-rsvp"
                              [class.attendee-rsvp--flag]="rsvpConfirmedForMissed(r.employeeId, o.eventName)">
                          {{ rsvpConfirmedForMissed(r.employeeId, o.eventName) ? 'Replied yes' : 'No reply' }}
                        </span>
                      </td>
                      <td>
                        <span class="participant-count"><i class="pi pi-users"></i> {{ o.participantCount }}</span>
                      </td>
                      <td>
                        <a *ngIf="o.photosFolderUrl" [href]="o.photosFolderUrl" target="_blank" rel="noopener"
                           pTooltip="View photos"><i class="pi pi-images"></i></a>
                        <span *ngIf="!o.photosFolderUrl" class="cell-sub">—</span>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </ng-container>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="5" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No participants found</p>
              <p class="empty-description">No one has participated yet for these filters.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Invited but did not participate — project → outing → people.
         Only Done outings appear (a Planning outing hasn't happened; a Cancelled one never did),
         and only those with at least one absentee. -->
    <p-table *ngIf="participationTab === 'notparticipated'"
             [value]="projectBreakdownRows" dataKey="projectId"
             [loading]="loading" [paginator]="projectBreakdownRows.length > 10" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]"
             [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} projects"
             styleClass="p-datatable-sm compact-striped-table">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem;"></th>
          <th>Project</th>
          <th>Outings</th>
          <th>Invited</th>
          <th>Participated</th>
          <th>Not participated</th>
          <th>Participation</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-p>
        <tr>
          <td>
            <button type="button" class="row-toggle-btn" (click)="toggleProject(p.projectId)" pTooltip="View outings">
              <i class="pi" [class.pi-chevron-down]="expandedProjects[p.projectId]" [class.pi-chevron-right]="!expandedProjects[p.projectId]"></i>
            </button>
          </td>
          <td>
            <div class="cell-strong">{{ p.projectName }}</div>
            <div class="cell-sub" *ngIf="p.projectCode">{{ p.projectCode }}</div>
          </td>
          <td>{{ p.outingCount }}</td>
          <td>{{ p.invitedCount }}</td>
          <td>{{ p.participatedCount }}</td>
          <td><p-tag [value]="p.absentCount + ''" severity="danger" styleClass="chip-tag" /></td>
          <td>
            <p-tag [value]="(p.participationRate | number:'1.0-1') + '%'"
                   [severity]="p.participationRate >= 80 ? 'success' : (p.participationRate >= 50 ? 'warn' : 'danger')"
                   styleClass="chip-tag" />
          </td>
        </tr>

        <!-- Level 2: this project's outings -->
        <tr class="expansion-row" *ngIf="expandedProjects[p.projectId]">
          <td colspan="7">
            <div class="participant-panel">
              <div class="participant-panel-title">Outings with absentees ({{ p.outings.length }})</div>
              <div class="outing-block" *ngFor="let o of p.outings">
                <button type="button" class="outing-block-head" (click)="toggleOuting(o.outingId)">
                  <i class="pi outing-block-chevron"
                     [class.pi-chevron-down]="expandedOutings[o.outingId]" [class.pi-chevron-right]="!expandedOutings[o.outingId]"></i>
                  <span class="outing-block-name">{{ o.eventName }}</span>
                  <span class="outing-block-meta">{{ o.plannedDate | date:'mediumDate' }}</span>
                  <span class="outing-block-meta">PM: {{ o.pmName }}</span>
                  <span class="outing-block-meta" *ngIf="o.location">{{ o.location }}</span>
                  <span class="outing-block-stats">
                    <span class="stat-pill stat-pill--ok">{{ o.participated.length }} participated</span>
                    <span class="stat-pill stat-pill--bad">{{ o.absent.length }} not participated</span>
                    <span class="stat-pill">{{ o.invitedCount }} invited</span>
                  </span>
                </button>

                <!-- Level 3: the two named lists, side by side -->
                <div class="attendee-split" *ngIf="expandedOutings[o.outingId]">
                  <div class="attendee-col">
                    <div class="attendee-col-title attendee-col-title--bad">
                      <i class="pi pi-ban"></i> Invited, did not participate ({{ o.absent.length }})
                    </div>
                    <div class="attendee-item" *ngFor="let a of o.absent">
                      <span class="attendee-name">{{ a.employeeName }}</span>
                      <span class="attendee-sg">{{ a.serviceGroupName || '—' }}</span>
                      <!-- Confirmed-yet-absent is the notable case: they said yes and still missed it. -->
                      <span class="attendee-rsvp" [class.attendee-rsvp--flag]="a.confirmed">
                        {{ a.confirmed ? 'RSVP: yes' : 'no reply' }}
                      </span>
                    </div>
                  </div>
                  <div class="attendee-col">
                    <div class="attendee-col-title attendee-col-title--ok">
                      <i class="pi pi-check-circle"></i> Participated ({{ o.participated.length }})
                    </div>
                    <div class="attendee-item" *ngFor="let a of o.participated">
                      <span class="attendee-name">{{ a.employeeName }}</span>
                      <span class="attendee-sg">{{ a.serviceGroupName || '—' }}</span>
                    </div>
                    <div class="attendee-empty" *ngIf="!o.participated.length">Nobody participated.</div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="7" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-check-circle"></i></div>
              <p class="empty-message">No absentees</p>
              <p class="empty-description">
                Everyone invited to a completed outing participated — or attendance hasn't been recorded yet.
                PMs record it when marking an outing done, and can correct it afterwards from the outings list.
              </p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Never invited employees -->
    <p-table *ngIf="participationTab === 'neverinvited'"
             [value]="neverInvitedRows" dataKey="employeeId"
             [loading]="loading" [paginator]="neverInvitedRows.length > 15" [rows]="15" [rowsPerPageOptions]="[15, 25, 50]"
             [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} employees"
             styleClass="p-datatable-sm compact-striped-table">
      <ng-template pTemplate="header">
        <tr>
          <th>Employee</th>
          <th>Service Group</th>
          <th>Email</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-r>
        <tr>
          <td class="cell-strong">{{ r.employeeName }}</td>
          <td>{{ r.serviceGroupName || '—' }}</td>
          <td class="cell-sub">{{ r.email || '—' }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="3" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-check-circle"></i></div>
              <p class="empty-message">Everyone was invited</p>
              <p class="empty-description">Every active employee was invited to at least one completed outing for these filters.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
